import { createContext, useContext } from 'react';

import type { FormType } from '@/store';

export const FormContext = createContext<FormType | null>(null);

export const useFormContext = () => {
  const ctx = useContext(FormContext);
  if (!ctx) {
    throw new Error('useFormContext must be used within a DocumentProvider');
  }
  return ctx;
};
